import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import {
  CHARGING_CARD_ORDER_ROUTE,
  FeatureToggleEnum,
  INTERNET_ROUTE,
  NEW_CLIENT_NEW_ADDRESS_ROUTE,
  NEW_CLIENT_ROUTE,
  SUPERSCHNELL_ROUTE,
} from '@mwe/constants';
import { Router } from '@angular/router';
import { IPopupModelV2, ModalChild, Sparte } from '@mwe/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { ClickableProductsCardComponent } from '../cards/clickable-products-card/clickable-products-card.component';
import { ModalComponent } from '../modal/modal.component';
import { getCompanyCorrelationFromCategory } from '@mwe/utils';
import { EnvironmentService, ProfileService } from '@mwe/services';

@Component({
  selector: 'mwe-order-products-popup',
  templateUrl: './order-products-popup.component.html',
  imports: [ClickableProductsCardComponent, ModalComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderProductsPopupComponent implements ModalChild {
  private readonly router = inject(Router);
  private readonly activeModal = inject(NgbActiveModal);
  private readonly profileService = inject(ProfileService);
  private readonly environmentService = inject(EnvironmentService);

  loadedData: boolean; // is being passed by popupService
  Sparte = Sparte;

  readonly popupModel = signal<IPopupModelV2>(null);

  readonly hasAllProducts = computed<boolean>(() => this.loadedData);
  readonly internetCardCategoryTranslationKeys: Record<string, string> = {
    [Sparte.Internet]: 'products.orderProducts.popup.newClient.internetCategory',
    [Sparte.Iptv]: 'products.orderProducts.popup.newClient.iptvCategory',
  };
  readonly title = computed<string>(() => `products.orderProducts.popup.title.${this.environmentService.getPortalCustomerType()}`);
  readonly stromCompany = computed<string>(() => getCompanyCorrelationFromCategory(Sparte.Strom));
  readonly waermeCompany = computed<string>(() => getCompanyCorrelationFromCategory(Sparte.Fernwaerme));
  readonly internetCompany = computed<string>(() => getCompanyCorrelationFromCategory(Sparte.Internet));
  readonly emobilityCompany = computed<string>(() => getCompanyCorrelationFromCategory(Sparte.Emobility));
  readonly internetAriaTitle = computed<string>(() =>
    this.profileService.isFeatureToggleEnabled(FeatureToggleEnum.INTERNET_V2_ENABLED)
      ? 'newClient.internet.entry'
      : 'newClient.internet.entry_ss',
  );

  startNewClientProcess(): void {
    this.closePopup();
    this.router.navigateByUrl(`/${NEW_CLIENT_ROUTE}/${NEW_CLIENT_NEW_ADDRESS_ROUTE}`);
  }

  startInternetProcess(): void {
    this.closePopup();

    if (this.profileService.isFeatureToggleEnabled(FeatureToggleEnum.INTERNET_V2_ENABLED)) {
      this.router.navigateByUrl(`/${INTERNET_ROUTE}/${NEW_CLIENT_NEW_ADDRESS_ROUTE}`);
    } else {
      this.router.navigateByUrl(`/${SUPERSCHNELL_ROUTE}/${NEW_CLIENT_NEW_ADDRESS_ROUTE}`);
    }
  }

  orderChargingCard(): void {
    this.closePopup();
    this.router.navigateByUrl(`/${CHARGING_CARD_ORDER_ROUTE}`);
  }

  closePopup(): void {
    this.activeModal.close();
  }
}
